// extracted by mini-css-extract-plugin
module.exports = {"category-dude-container":"CategoryDudeImage_category-dude-container__7RIwJ","container":"CategoryDudeImage_container__iWKgu"};